export default "__VITE_ASSET__B8AgaaLa__"